<mat-label class="subHeading ">TP Payout</mat-label>

<div formGroupName="tp_percent" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="4" type="text" class="w-50 m-0" placeholder="From" appNumberOnly appPercentOnly>
    -
    <input formControlName="to" [maxlength]="4" type="text" class="w-50 m-0" placeholder="To" appNumberOnly appPercentOnly>
</div>
<p
    class="text-danger"
    *ngIf="
        rangeForm.controls['from'].hasError('small')
        ||
        rangeForm.controls['to'].hasError('small')
    "
>
Invalid range for values
</p>
